import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";


const getAbsence = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}get_all_absence`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json, text/plain, */*'
        }
    }) 
}

export default getAbsence